// import React, { useEffect } from "react";
import Logo from "../../Assets/Machcity Logo.png";
import Form from "./ClaimForm.jsx";
import Footer from "../MachCity/Footer.jsx";
import { Link } from "react-router-dom";
import { Toaster } from "react-hot-toast";

function MachClaim() {
  // useEffect(() => {
  //   document.title = "Warranty Claim Registration Form - Machcity"
  // })
  return (
    <section>
      <Toaster />
      <div className="bg-black w-full">
        {/* Navigation Bar */}
        <nav className="mx-auto max-w-7xl px-4 pt-5 sm:px-6 lg:px-8 flex items-center">
          <div className="flex w-full items-center justify-between">
            {/* Logo */}
            <img
              src={Logo}
              alt="MachCity logo"
              // className="sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-auto lg:h-auto"
            />

            {/* Menu Icon */}
            <div>
              <ul>
                <li>
                  <Link to="/" className="text-white font-medium">
                    Warranty Register
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Placeholder for Form */}
        <Form />
        {/* <ClaimForm /> */}

        {/* Footer */}
        <Footer />
      </div>
    </section>
  );
}

export default MachClaim;
